var _circle, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEditUrgent(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.7,
    cx: 8,
    cy: 8,
    r: 8,
    fill: "#F32020"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.49021 5.136L7.9996 8.57031L7.50898 5.136C7.46633 4.83743 7.698 4.57031 7.9996 4.57031C8.30119 4.57031 8.53287 4.83743 8.49021 5.136Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.94354 5.21803L7.43416 8.65234L8.56553 8.65234L9.05615 5.21803C9.14798 4.57522 8.64918 4.0001 7.99984 4.0001C7.35051 4.0001 6.85171 4.57522 6.94354 5.21803Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.85686 10.8571C6.85686 10.226 7.36854 9.71429 7.99972 9.71429C8.6309 9.71429 9.14258 10.226 9.14258 10.8571C9.14258 11.4883 8.6309 12 7.99972 12C7.36854 12 6.85686 11.4883 6.85686 10.8571Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditUrgent);
export default __webpack_public_path__ + "static/media/edit-urgent.b4d249e8.svg";
export { ForwardRef as ReactComponent };